import React, { FC, useEffect } from "react";
import style from "./style.module.scss";

interface IModalWrapper {
  children: React.ReactNode;
  modalCloseHandler: () => void;
}

export const ModalWrapper: FC<IModalWrapper> = ({
  children,
  modalCloseHandler,
}) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        modalCloseHandler();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  return (
    <div className={style.wrapper} onClick={modalCloseHandler}>
      {children}
    </div>
  );
};
